import { z } from "zod";

/**
 * Validation schema for `RedeemRewardInput`
 * (`{ catalogItemId: ID!, quantity: Int = 1, purchaseReference: String }`).
 * Cost, eligibility and inventory are decided by the server; the client only
 * says which item and how many.
 */
export const redeemRewardSchema = z.object({
  catalogItemId: z.string().trim().min(1, { message: "catalog_item_required" }),
  quantity: z
    .number()
    .int({ message: "quantity_invalid" })
    .positive({ message: "quantity_invalid" })
    .optional(),
  purchaseReference: z.string().trim().max(120, { message: "max_characters_error" }).optional(),
});

export type RedeemRewardFormValues = z.infer<typeof redeemRewardSchema>;
